"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYER_PUBKEY = void 0;
const web3_js_1 = require("@solana/web3.js");
/**
 * The stand-in pubkey for delegating a payer address to a worker.
 * All workers are re-imbursed by the user for lamports spent during this delegation.
 * https://docs.rs/clockwork-utils/latest/clockwork_utils/static.PAYER_PUBKEY.html
 */
const PAYER_PUBKEY = new web3_js_1.PublicKey("C1ockworkPayer11111111111111111111111111111");
exports.PAYER_PUBKEY = PAYER_PUBKEY;
